var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91654 15.4211V17H16.1143C17.466 17 18.6182 16.5121 19.5708 15.5363C20.5236 14.5607 21 13.3814 21 11.9984C21 10.6156 20.5236 9.43684 19.5708 8.46211C18.6182 7.48737 17.466 7 16.1143 7H7.11429V8.57895H12.6429C12.2446 8.93789 11.938 9.34342 11.7231 9.79553C11.5081 10.2476 11.3643 10.7193 11.2918 11.2105H5.05714V12.7895H11.2918C11.371 13.3077 11.5214 13.7912 11.7429 14.24C11.9643 14.6886 12.2643 15.0823 12.6429 15.4211H6.91654Z",
    fill: "#3469E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.4211V17H5.88797V15.4211H3Z",
    fill: "#3469E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripsActive);
export default __webpack_public_path__ + "static/media/trips-active.cbc43bbae44e599151f3075f647a5163.svg";
export { ForwardRef as ReactComponent };